import { render } from "./HALT_SPRINT_NOTIFICATION.vue?vue&type=template&id=68983e99&scoped=true&ts=true"
import script from "./HALT_SPRINT_NOTIFICATION.vue?vue&type=script&lang=ts"
export * from "./HALT_SPRINT_NOTIFICATION.vue?vue&type=script&lang=ts"

import "./HALT_SPRINT_NOTIFICATION.vue?vue&type=style&index=0&id=68983e99&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68983e99"]])

export default __exports__